import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root {
        ${(props) =>
          props.theme.fontBreakpoints
            .map((bp, index) => {
              if (index === 0) return `font-size: ${props.theme.rootFontSize};`;

              return `@media (min-width: ${bp}px) {font-size: calc(${props.theme.rootFontSize} + ${index}px);}`;
            })
            .join('\n')}
    }

    body {
        background-image: url(/assets/background.jpg), url(/assets/background_repeat.jpg);
        background-size: 100%, 100%;
        background-repeat: no-repeat, repeat-y;

        color: ${(props) => props.theme.colors.text};
        margin: 0;
        min-height: 100vh;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: ${(props) => props.theme.sizes[0]};
        line-height: 1;
        font-weight: 400;
        font-variant-numeric: tabular-nums;
    }

    a {
        text-decoration: none;
        color: ${(props) => props.theme.colors.link};

        &:hover {
            color: ${(props) => props.theme.colors.linkHover};
        }
    }

    p {
        margin: 0;
        line-height: normal;
    }
`;
